import React, { useCallback, useState } from 'react';
import { Spinner } from '@unite-us/app-components';
import { get } from 'lodash';
import { useIsClientsDrawer } from '../context/InteractionsContext';
import usePagination from '../hooks/usePagination';
import { useInteractions } from '../hooks/useInteractions';
import { StructuredInteractionsForm } from './form/StructuredInteractionsForm';
import { Pagination } from './Pagination';
import { StructuredInteractionsHeader } from './StructuredInteractionsHeader';
import { StructuredInteractionsList } from './StructuredInteractionsList';

export function InteractionsContent() {
  const isClientsDrawer = useIsClientsDrawer();
  const paginationProps = usePagination();
  const { interactions, data, isLoading } = useInteractions({
    pageNumber: paginationProps.pageNumber,
    pageSize: paginationProps.pageSize,
  });
  const [isFormOpen, setIsFormOpen] = useState(false);

  const totalItemCount = get(data, 'data.meta.page.total_count', 0);
  const totalPageCount = get(data, 'data.meta.page.total_pages', 0);

  const openForm = useCallback(() => setIsFormOpen(true), []);
  const closeForm = useCallback(() => setIsFormOpen(false), []);

  return (
    <div
      className={`structured-interactions panel-wrapper ${isClientsDrawer ? 'mb-4' : 'mb-6'}`}
      data-test-element="structured-interactions"
    >
      <StructuredInteractionsHeader
        disabled={isFormOpen}
        labelText="Add Interaction"
        onClick={openForm}
        title="Interactions"
      />
      {isFormOpen && (
        <StructuredInteractionsForm onClose={closeForm} />
      )}
      {isLoading ? (
        <Spinner scale={0.45} />
      ) : (
        <StructuredInteractionsList interactions={interactions} />
      )}
      {!isClientsDrawer && (
        <Pagination
          {...paginationProps}
          totalItemCount={totalItemCount}
          totalPageCount={totalPageCount}
        />
      )}
    </div>
  );
}
